class NonUSAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.closeAnnouncementBtn = this.querySelector(".announcement-bar__close");

    window.addEventListener("OneTrustGroupsUpdated", () => {
      if (NonUSAnnouncementBar.isUSRegion()) return;
      this.classList.remove("hidden");
      this.setCloseEventListener();
    });

    if (window.Shopify?.designMode) {
      document.addEventListener("shopify:section:load", () => {
        setTimeout(() => {
          this.closeAnnouncementBtn = this.querySelector(
            ".announcement-bar__close",
          );
          this.setCloseEventListener();
        });
      });
    }
  }

  setCloseEventListener() {
    if (!this.closeAnnouncementBtn) return;
    this.closeAnnouncementBtn.removeEventListener("click", this.closeHandler);
    this.closeHandler = () => {
      this.classList.add("hidden");
    };
    this.closeAnnouncementBtn.addEventListener("click", this.closeHandler);
  }

  static isUSRegion() {
    const regionCode = window.Shopify.customerPrivacy.getRegion();
    return regionCode.startsWith("US");
  }
}

if (!customElements.get("non-us-announcement-bar")) {
  customElements.define("non-us-announcement-bar", NonUSAnnouncementBar);
}
